import { p as proxyCustomElement, H, h } from './p-23afa4c1.js';
import { d as defineCustomElement$4 } from './p-eddedf58.js';
import { d as defineCustomElement$3 } from './p-8938db8f.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';
import { h as hasNamedSlot } from './p-bde29a8a.js';

const cosmosProductItemCss = ".cosmos-product-item{--cosmos-asset-item-base-gap:var(--cosmos-product-item-gap);--cosmos-asset-item-base-headline-color:var(--cosmos-product-item-name-color);--cosmos-asset-item-base-headline-font-family:var(--cosmos-product-item-name-font-family);--cosmos-asset-item-base-headline-font-size:var(--cosmos-product-item-name-font-size);--cosmos-asset-item-base-headline-font-style:var(--cosmos-product-item-name-font-style);--cosmos-asset-item-base-headline-font-weight:var(--cosmos-product-item-name-font-weight);--cosmos-asset-item-base-headline-letter-spacing:var(--cosmos-product-item-name-letter-spacing);--cosmos-asset-item-base-headline-line-height:var(--cosmos-product-item-name-line-height);--cosmos-asset-item-base-headline-text-transform:var(--cosmos-product-item-name-text-transform);--cosmos-asset-item-base-meta-text-primary-color:var(--cosmos-product-item-text-color);--cosmos-asset-item-base-meta-text-primary-font-family:var(--cosmos-product-item-text-font-family);--cosmos-asset-item-base-meta-text-primary-font-size:var(--cosmos-product-item-text-font-size);--cosmos-asset-item-base-meta-text-primary-font-style:var(--cosmos-product-item-text-font-style);--cosmos-asset-item-base-meta-text-primary-font-weight:var(--cosmos-product-item-text-font-weight);--cosmos-asset-item-base-meta-text-primary-letter-spacing:var(--cosmos-product-item-text-letter-spacing);--cosmos-asset-item-base-meta-text-primary-line-height:var(--cosmos-product-item-text-line-height);--cosmos-asset-item-base-meta-text-primary-text-transform:var(--cosmos-product-item-text-text-transform);--cosmos-asset-item-base-meta-text-additional-color:var(--cosmos-product-item-additional-info-color);--cosmos-asset-item-base-meta-text-additional-font-family:var(--cosmos-product-item-additional-info-font-family);--cosmos-asset-item-base-meta-text-additional-font-size:var(--cosmos-product-item-additional-info-font-size);--cosmos-asset-item-base-meta-text-additional-font-style:var(--cosmos-product-item-additional-info-font-style);--cosmos-asset-item-base-meta-text-additional-font-weight:var(--cosmos-product-item-additional-info-font-weight);--cosmos-asset-item-base-meta-text-additional-letter-spacing:var(--cosmos-product-item-additional-info-letter-spacing);--cosmos-asset-item-base-meta-text-additional-line-height:var(--cosmos-product-item-additional-info-line-height);--cosmos-asset-item-base-meta-text-additional-text-transform:var(--cosmos-product-item-additional-info-text-transform)}.cosmos-product-item__image{--cosmos-image-border-radius:var(--cosmos-product-item-image-radius, 4px);height:100%}.cosmos-product-item__additional-info{display:-ms-flexbox;display:flex}.cosmos-product-item__additional-info ::slotted([slot=additional-info-prefix]){-webkit-margin-end:4px;margin-inline-end:4px}";
const CosmosProductItemStyle0 = cosmosProductItemCss;

const generateClassNames = bem('cosmos-product-item');
const CosmosProductItem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosProductItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.additionalInfo = undefined;
        this.appearance = undefined;
        this.href = undefined;
        this.image = undefined;
        this.name = undefined;
        this.rel = undefined;
        this.size = 'small';
        this.target = undefined;
        this.text = undefined;
    }
    hasAdditionalInfoSlot() {
        return hasNamedSlot(this.element, 'additional-info-prefix');
    }
    getImageAppearance() {
        return this.appearance ? (this.appearance === 'dark' ? 'light' : 'dark') : undefined;
    }
    render() {
        return (h("cosmos-asset-item-base", { key: '72f5134d4ba1172e3de19f79c4d23f8b39a4984a', appearance: this.appearance, class: generateClassNames(), exportparts: "base: base, headline: name,  meta-text-primary: text, additional-info: additional-info", headline: this.name, headlineClamp: 2, href: this.href, metaTextPrimary: this.text, metaTextPrimaryClamp: true, metaTextAdditional: this.additionalInfo, rel: this.rel, size: this.size, target: this.target }, h("cosmos-image", { key: '9cb6cf89b4bc6debe76c2e1212ef5577b27f3512', appearance: this.getImageAppearance(), class: generateClassNames('image'), exportparts: "base: image", fit: "contain", image: this.image, slot: "image" }), this.hasAdditionalInfoSlot() && (h("div", { "aria-hidden": "true", slot: "meta-text-additional-info-prefix", class: generateClassNames('additional-info') }, h("slot", { name: "additional-info-prefix" })))));
    }
    get element() { return this; }
    static get style() { return CosmosProductItemStyle0; }
}, [1, "cosmos-product-item", {
        "additionalInfo": [513, "additional-info"],
        "appearance": [513],
        "href": [513],
        "image": [513],
        "name": [513],
        "rel": [513],
        "size": [513],
        "target": [513],
        "text": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-product-item", "cosmos-asset-item-base", "cosmos-image", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-product-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosProductItem$1);
            }
            break;
        case "cosmos-asset-item-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-image":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosProductItem = CosmosProductItem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosProductItem, defineCustomElement };
